//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dashboard, dashboard_list } from "@/apis/dashboard";
import { sportType_list, area_list } from "@/apis/config";
import { fetchAll } from "@/apis/mch";
import { venues_list } from "@/apis/stadium";
import { sysConfigs_stadiumConfig } from '@/apis/system'

import moment from "moment";

import WidgetCounter from "../../components/Widgets/WidgetCounter";
import ChartLine from "../../components/Charts/ChartLine.vue";

const stats = {
  addMemberTotal: 0,
  stadiumTotal: 0,
  addMch: 0,
  mchTotal: 0,
  checkOrderTotal: 0,
  addStadiumTotal: 0,
  orderTotal: 0,
  rechargeNotUsedAmount: 0,
  noCheckOrderTotal: 0,
  rechargeAmount: 0,
  checkOrderRate: 0,
  payOrderTotal: 0,
  notPayOrderTotal: 0,
  rechargeUsedAmount: 0,
  sellOrderRate: 0,
};

const tableColumns = [
  {
    title: "品牌名稱",
    dataIndex: "mchName",
    key: "mchName",
  },
  {
    title: "分館名稱",
    dataIndex: "venueName",
    key: "venueName",
  },
  {
    title: "地區",
    dataIndex: "areaName",
    key: "areaName",
  },
  {
    title: "場地數量",
    dataIndex: "fieldTotal",
    key: "fieldTotal",
  },
  {
    title: "時段數量",
    dataIndex: "timeSlotTotal",
    key: "timeSlotTotal",
  },
  {
    title: "會員數",
    dataIndex: "memberTotal",
    key: "memberTotal",
  },
  {
    title: "售票數",
    dataIndex: "payOrderTotal",
    key: "payOrderTotal",
  },
  {
    title: "售票金額",
    dataIndex: "payOrderAmount",
    key: "payOrderAmount",
  },
  {
    title: "售票率",
    dataIndex: "payOrderRate",
    key: "payOrderRate",
    scopedSlots: { customRender: "centSlot" },
  },
  {
    title: "退票數",
    dataIndex: "returnOrderCnt",
    key: "returnOrderCnt",
  },
  {
    title: "出席票",
    dataIndex: "checkOrderTotal",
    key: "checkOrderTotal",
  },
  {
    title: "noshow票",
    dataIndex: "noCheckOrderRate",
    key: "noCheckOrderRate",
    scopedSlots: { customRender: "centSlot" },
  },
  {
    title: "出席率",
    dataIndex: "checkOrderRate",
    key: "checkOrderRate",
    scopedSlots: { customRender: "centSlot" },
  },
  {
    title: "開場成功率",
    dataIndex: "startOrderRate",
    key: "startOrderRate",
    scopedSlots: { customRender: "centSlot" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  components: {
    WidgetCounter,
    ChartLine,
  },
  data() {
    return {
      loading: false,
      searchQuery: {
        areacode: undefined,
        sportType: undefined,
        venueCode: undefined,
        mchNo: "",
        date: "",
        sDate: undefined,
        eDate: undefined,
      },
      searchConfig: {
        motions: [],
        areas: [],
        fetchs: [],
      },

      // Associating table data with its corresponding property.
      tableData: [],

      // Associating table columns with its corresponding property.
      tableColumns: tableColumns,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },

      // Counter Widgets Stats
      stats,
      defaultStats: stats,
      checkStrictly: false,
      formState: {},
      lineChartData: {
        labels: ["週壹", "週二", "週三", "週四", "週五", "週六", "週日"],
        datasets: [
          {
            label: "數據2",
            tension: 0.4,
            borderWidth: 0,
            pointRadius: 0,
            borderColor: "#1890FF",
            borderWidth: 3,
            data: [50, 40, 300, 220, 500, 250, 400],
            maxBarThickness: 6,
          },
          {
            label: "數據1",
            tension: 0.4,
            borderWidth: 0,
            pointRadius: 0,
            borderColor: "#B37FEB",
            borderWidth: 3,
            data: [30, 90, 40, 140, 290, 290, 340],
            maxBarThickness: 6,
          },
        ],
      },
      lineChartData2: {
        labels: ["週壹", "週二", "週三", "週四", "週五", "週六", "週日"],
        datasets: [
          {
            label: "數據1",
            tension: 0.4,
            borderWidth: 0,
            pointRadius: 0,
            borderColor: "#1890FF",
            borderWidth: 3,
            data: [20000, 19800, 20200, 22000, 21500, 23500, 24000],
            maxBarThickness: 6,
          },
          {
            label: "數據2",
            tension: 0.4,
            borderWidth: 0,
            pointRadius: 0,
            borderColor: "#B37FEB",
            borderWidth: 3,
            data: [10000, 13000, 12600, 13400, 13500, 13100, 13102],
            maxBarThickness: 6,
          },
        ],
      },
    };
  },
  created() { },
  mounted() {
    this.$nextTick(async () => {
      const now = new Date();
      this.searchQuery.sDate = `${now.getFullYear()}-01-01 00:00:00`;
      this.searchQuery.eDate = `${now.getFullYear()}-12-31 23:59:59`;
      this.searchQuery.date = [this.searchQuery.sDate, this.searchQuery.eDate];
      await this.onPageConfig();
      await this.onPageLoad();

      if (this.$access('ENT_DASHBOARD_VIEW_LIST')) {
        await this.onPageListLoad();
      }


    });
  },
  methods: {
    //頁面事件
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.onPageListLoad(true);
    },
    async getSportTypeList() {
      try {
        const params = {
          fieldName: "",
          venueCode: "",
          status: "",
          sportTypeCode: "",
          pageSize: 99,
          pageNumber: 1,
        };
        const res = (await sportType_list(params)) || {};
        if (res.code == 0) {
          this.searchConfig.motions = res.data.records;
        } else {
          if (res.msg) throw new Error(res.msg);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getAreaList() {
      try {
        const configOpenArea = await this.getStadiumConfig();
        this.searchConfig.areas = configOpenArea;
        // const res = (await area_list()) || {};
        // if (res.code == 0) {
        //   let items = res.data;
        //   let topLevelList = items.filter(
        //     (item) => item.parentCode == 7100000000000
        //   );

        //   topLevelList.forEach((childrenItem) => {
        //     childrenItem.children = items.filter(
        //       (item) => item.parentCode == childrenItem.areaCode
        //     );
        //   });
        //   this.searchConfig.areas = topLevelList;
        // } else {
        //   if (res.msg) throw new Error(res.msg);
        // }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getStadiumConfig() {
      try {
        const res = await sysConfigs_stadiumConfig() || {};
        if (res.code == 0) {
          const list = res.data || [];
          const openAreaRes = list.filter(item => item.configKey == 'openArea');
          if (openAreaRes.length > 0) {
            try {
              return JSON.parse(openAreaRes[0].configVal);
            } catch (error) {
              return openAreaRes[0].configVal;
            }

          } else {
            return undefined;
          }
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error.message);
      }
    },

    async getFetchList() {
      try {
        const res =
          (await fetchAll({
            name: "",
            status: "1",
            pageSize: 99999,
            pageNumber: 1,
          })) || {};
        if (res.code == 0) {
          await this.getVenuesList(res.data.records);
        } else {
          if (res.msg) throw new Error(res.msg);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getVenuesList(items) {
      try {
        const res =
          (await venues_list({
            venueCode: "",
            venueName: "",
            sportTypeCode: "",
            status: 1,
            areaCode: "",
            pageSize: 9999,
            pageNumber: 1,
          })) || {};
        if (res.code == 0) {
          console.log("items", items);
          if (items.length > 0) {
            items.forEach((item) => {
              item.children = res.data.records.filter(
                (childrenItem) => childrenItem.mchNo == item.mchNo
              );
            });
            this.searchConfig.fetchs = items.filter(
              (item) => item.children.length > 0
            );
          }
        } else {
          if (res.msg) throw new Error(res.msg);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    async onPageConfig() {
      await this.getSportTypeList();
      await this.getAreaList();
      await this.getFetchList();
    },
    async onPageLoad() {
      try {
        const res = await dashboard({
          ...this.searchQuery,
        });
        this.stats = res.data || this.defaultStats;
      } catch (error) {
        this.$message.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    async onPageListLoad() {
      try {
        const res = await dashboard_list({
          ...this.searchQuery,
        });
        console.log(`output->res`, res);
        this.tableData = res.data.records;
        this.pagination.total = res.data.total;
        // this.stats = res.data;/
      } catch (error) {
        this.$message.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    onSelect: (record, selected, selectedRows) => {
      console.log(record, selected, selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
    handleSearchSubmit() {
      this.onPageLoad();
    },
    handleResetSearchSubmit() {
      this.searchQuery.areacode = undefined;
      this.searchQuery.sportType = undefined;
      this.searchQuery.venueCode = undefined;
      this.searchQuery.mchNo = "";
      const now = new Date();
      this.searchQuery.sDate = `${now.getFullYear()}-01-01 00:00:00`;
      this.searchQuery.eDate = `${now.getFullYear()}-12-31 23:59:59`;
      this.searchQuery.date = [this.searchQuery.sDate, this.searchQuery.eDate];
      // this.searchQuery.date = "";
      // this.searchQuery.sDate = undefined;
      // this.searchQuery.eDate = undefined;
      this.onPageLoad();
    },
  },
};
